import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { useTheme, createUseStyles } from 'react-jss';
import { Container } from '@sm/wds-react';
import { Typography } from '@wds/typography';
import { IconCheck } from '@sm/wds-icons';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.NonBranded.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The only message on the webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },
});

const useStyles = createUseStyles(theme => {
  return {
    container: {
      height: theme.util.fullHeight,
    },
  };
});

const EmbeddedNonBranded = () => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Container className={classes.container} flex flexAlign="center" flexJustify="center" flexDirection="column">
      <Container flexInline>
        <IconCheck color="dark" size="md" />
        <Typography color="dark" component="div" pl={2} variant="body">
          {t(COPY.THANK_YOU)}
        </Typography>
      </Container>
    </Container>
  );
};

export default EmbeddedNonBranded;
